import HomePage from '../views/Home/';
import Agreement from '../views/Agreement';
import SelectCarModel from '../views/SelectCarModel';
import SelectPackage from '../views/SelectPackage';
import PersonalInfo from '../views/PersonalInfo';
import EnterEmail from '../views/EnterEmail';
import Summary from '../views/Summary';
import SendReport from '../views/SendReport';
import Payment from '../views/Payment';
import VerifyOTP from '../views/VerifyOTP';
import PaymentSuccess from '../views/PaymentSuccess';
import PaymentSuccessMotor from '../views/PaymentSuccessMotor';
import Callback from '../views/Callback'

import ErrorSystem from '../views/ErrorSystem'
import ErrorPayment from '../views/ErrorPayment'
import ErrorBuy from '../views/ErrorBuy'
import ErrorMaintenance from '../views/ErrorMaintenance'
import ErrorNetwork from '../views/ErrorNetwork'
import ErrorPaymentSystem from '../views/ErrorPaymentSystem'
import ErrorPaymentTimeout from '../views/ErrorPaymentTimeout'

const motorRoutes = [
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement
  },
  {
    path: '/select-car-model',
    name: 'Select Car Model',
    component: SelectCarModel
  },
  {
    path: '/select-package',
    name: 'Select package',
    component: SelectPackage
  },
  {
    path: '/personal-info',
    name: 'Personal Info',
    component: PersonalInfo
  },
  {
    path: '/enter-email',
    name: 'Enter Email',
    component: EnterEmail
  },
  {
    path: '/summary',
    name: 'Summary',
    component: Summary
  },
  {
    path: '/send-report',
    name: 'SendReport',
    component: SendReport
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/verify-otp',
    name: 'Verify top',
    component: VerifyOTP
  },
  {
    path: '/payment-success',
    name: 'Payment Success',
    component: PaymentSuccess
  },
  {
    path: '/payment-success-motor',
    name: 'Payment Success Motor',
    component: PaymentSuccessMotor
  },
  {
    path: '/tmn_callback',
    name: 'Callback',
    component: Callback
  },

  {
    path: '/error-system',
    name: 'ErrorSystem',
    component: ErrorSystem
  },
  {
    path: '/error-payment',
    name: 'ErrorPayment',
    component: ErrorPayment
  },
  {
    path: '/error-payment-system',
    name: 'ErrorPaymentSystem',
    component: ErrorPaymentSystem
  },
  {
    path: '/error-payment-timeout',
    name: 'ErrorPaymentTimeout',
    component: ErrorPaymentTimeout
  },
  {
    path: '/error-buy',
    name: 'ErrorBuy',
    component: ErrorBuy
  },
  {
    path: '/error-maintenance',
    name: 'ErrorMaintenance',
    component: ErrorMaintenance
  },
  {
    path: '/error-network',
    name: 'ErrorNetwork',
    component: ErrorNetwork
  },
  { redirect: true, path: '/', pathTo: '/home', name: 'Home' }
];

export default motorRoutes;
